<!--
 * @Description: 内容列表
 * @Date: 2021-02-02 16:56:36
-->

<template>
  <div class="content-list" @touchmove="preLoad()">
    <categoryTab @change="changeTab" :keyword="keyword"></categoryTab>
    <div style="position:relative;min-height: 6rem" v-show="pageObj.menuId">
      <defaultList v-bind="$data" :defaultMid="true">
        <div class="content-list__items">
          <listItem v-for="(item, index) in listData" :key="index" :item="item"></listItem>
        </div>
      </defaultList>
    </div>
  </div>
</template>

<script>
import categoryTab from './categoryTab.vue';
import defaultList from './defaultList.vue';
import listItem from './listItem.vue';
import { querychannelCourseList } from '@/api/home';
import { loadMore } from '@/mixins/loadMore';

export default {
  name: 'ContentList',
  mixins: [loadMore],
  props: {
    // 外部传入的
    getListAjax: {
      type: Function,
      default() {
        return querychannelCourseList;
      }
    },
    // 搜索
    keyword: ''
  },
  data() {
    return {
      listAjax: this.getListAjax()
    };
  },
  components: {
    categoryTab,
    defaultList,
    listItem
  },
  methods: {
    async changeTab(item) {
      this.pageObj.menuId = item.id;
      this.pageObj.searchName = this.keyword;
      this.getList({
        init: true
      });
    }
  }
};
</script>

<style lang="scss">
.content-list {
  padding: 0.12rem 0;
  &__items {
    padding: 0.4rem 0.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>
